import { keysToCamelCase } from "zod-to-camel-case";

import type {
  SyntheticProgrammesByYear,
  SyntheticProgrammesByYearCamel,
} from "@/schema/published/syntheticProgrammesByYear/syntheticProgrammesByYear.schema";
import { programmeFieldsFixture } from "@/schema/public/components/programmeFields/programmeFields.fixture";

export const syntheticProgrammesByYearFixture = ({
  overrides = {},
}: {
  overrides?: Partial<SyntheticProgrammesByYear>;
} = {}): SyntheticProgrammesByYear => ({
  year_slug: "year-1",
  base_slug: "maths-primary-year-1",
  programme_slug: "maths-primary-year-1",
  is_legacy: false,
  programme_fields: programmeFieldsFixture(),
  ...overrides,
});

export const syntheticProgrammesByYearFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<SyntheticProgrammesByYearCamel>;
} = {}): SyntheticProgrammesByYearCamel => ({
  ...keysToCamelCase(syntheticProgrammesByYearFixture()),
  ...overrides,
});
